import React, { useState, useEffect } from "react";

function App() {
  const [query, setQuery] = useState("");
  const [tag, setTag] = useState(""); 
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);

  useEffect(() => {
    fetch("/data/user_search.php?q=test") 
      .then((res) => {
        if (res.status === 403) {
          setAccessDenied(true);
          return Promise.reject("Access Denied");
        }
        return res.json();
      })
      .then(() => setAccessDenied(false))
      .catch(() => setAccessDenied(true));
  }, []);
      const tagColors = {
        "Board Member": "#2581c4",
        "Contractor": "#aaa",
        "Donor": "#da3e78",
        "Fills Presenter": "#c2c100",
        "Friend of RRR": "#65d3c4",
        "Graveyarder": "#d1c500",
        "Lifetime Subscriber": "#2a9925",
        "Panel Operator": "#836a24",
        "Past Board Member": "#6e8fcf",
        "Past Presenter": "#2cb187",
        "Past Staff": "#a17aa8",
        "Past Volunteer": "#92d9a0",
        "Pet": "#ea0bf7",
        "Presenter": "#f8e71c",
        "Segment Presenter": "#d9a703",
        "Staff": "#7a08e3",
        "Subscriber": "#dd1616",
        "Volunteer": "#0cf01a",
      };
  const handleSearch = (e) => {
    e.preventDefault();
    setLoading(true);
    setAccessDenied(false);

    // Include tag in fetch request
    fetch(`/data/user_search.php?q=${encodeURIComponent(query)}&tag=${encodeURIComponent(tag)}`)
      .then((res) => {
        if (res.status === 403) {
          setAccessDenied(true);
          return Promise.reject("Access Denied");
        }
        return res.json();
      })
      .then((data) => setResults(data))
      .catch(() => setResults([]))
      .finally(() => setLoading(false));
  };

  return (
    <div style={styles.container}>
      {accessDenied ? (
        <div style={styles.accessDenied}>
          <h1>Access Denied</h1>
          <p>You must log in to access this page.</p>
          <a href="/google/google-oauth.php" style={styles.button}>
            Login with Google
          </a>
        </div>
      ) : (
        <>
          <h1>Search Users</h1>
          <form onSubmit={handleSearch} style={styles.form}>
            <input
              type="text"
              placeholder="Enter name, phone, or email"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              style={styles.input}
            />
            <select
              value={tag}
              onChange={(e) => setTag(e.target.value)}
              style={styles.select}
            >
              <option value="">Filter by tags</option>
              <option value="Volunteer">Volunteer</option>
              <option value="Presenter">Presenter</option>
              <option value="Staff">Staff</option>
              <option value="Board Member">Board Member</option>
              <option value="Fills Presenter">Fills Presenter</option>
              <option value="Graveyarder">Graveyarder</option>
              <option value="Friend of RRR">Friend of RRR</option>
              <option value="Segment Presenter">Segment Presenter</option>
              <option value="Contractor">Contractor</option>
              <option value="Past Volunteer">Past Volunteer</option>
              <option value="Past Board Member">Past Board Member</option>
              <option value="Past Presenter">Past Presenter</option>
              <option value="Past Staff">Past Staff</option>
              <option value="Panel Operator">Panel Operator</option>
           
          
             
        
                    
             
            </select>
            <button type="submit" style={styles.button}>Search</button>
          </form>

          {loading && <p style={styles.loading}>Searching...</p>}

          <div style={styles.results}>
            {results.length ? (
              results.map((user, index) => (
                <div key={index} style={styles.card}>
                  <div style={{ marginBottom: '0.5rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                   {user["tags.name"]?.split(',').map((tag, i) => (
                <span key={i} style={{
                  backgroundColor: tagColors[tag.trim()] || "#999",
                  color: 'white',
                  borderRadius: '12px',
                  padding: '4px 10px',
                  fontSize: '0.8rem',
                  fontWeight: 'bold'
                }}>
                  {tag}
                </span>
              ))}
                  </div>
                  <p><strong>Name:</strong> {user.nick_name ? ` "${user.nick_name}" ` : ''}{user.display_name}</p>
                  <p><strong>Email:</strong>{' '}
                  {user["email.email"] ? user["email.email"] : 'N/A'}
                </p>
                  <p>
                  <strong>Phone:</strong>{' '}
                  {user["phone.phone"] ? (
                    <a href={`tel:${user["phone.phone"]}`} className="text-blue-600 underline">
                      {user["phone.phone"]}
                    </a>
                  ) : (
                    'N/A'
                  )}
                </p>
                </div>
              ))
            ) : (
              !loading && <p>No results found</p>
            )}
          </div>
        </>
      )}
    </div>
  );
}

const styles = {
  container: { padding: "20px"},
  select: { padding: "10px", fontSize: "16px" },
  input: { padding: "10px", fontSize: "16px", marginRight: "10px" },
  button: { padding: "10px 15px",marginLeft:"10px", fontSize: "16px", backgroundColor: "blue", color: "white", textDecoration: "none", display: "inline-block", marginTop: "10px" },
  loading: { fontSize: "18px", color: "blue" },
  accessDenied: { fontSize: "18px", color: "red", marginTop: "20px" },
  results: { marginTop: "20px" },
  card: { backgroundColor: "#f4f4f4", padding: "10px", marginBottom: "10px", borderRadius: "5px" },
};

export default App;
